import { normalize, arrayOf } from 'normalizr';

import * as schemas from '../schemas';
import toRecords from '../normalizers';

export function files(responseData) {
  const data = normalize(responseData, arrayOf(schemas.fileSchema));
  return {
    ...toRecords(data),
    ids: data.result,
  };
}
